export const LOGIN_STARTED = 'LOGIN_STARTED'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'

export const SIMPLE_SIGN_UP_STARTED = 'SIMPLE_SIGN_UP_STARTED'
export const SIMPLE_SIGN_UP_FINISHED = 'SIMPLE_SIGN_UP_FINISHED'

export const REFRESH_TOKEN_SUCCESS = 'REFRESH_TOKEN_SUCCESS'

export const LOGOUT = 'LOGOUT'
export const SET_USER_INFO = 'SET_USER_INFO'

export const LIST_FILEDS_SUCCESS = 'LIST_FILEDS_SUCCESS'
export const SET_FIELD_DETAIL = 'SET_FIELD_DETAIL'
export const SET_CURRENT_FIELD_TASKS = 'SET_CURRENT_FIELD_TASKS'
export const UPDATE_PAGING_OPTIONS_OF_CURRENT_FIELD_TASKS = 'UPDATE_PAGING_OPTIONS_OF_CURRENT_FIELD_TASKS'

export const CLEANUP_CURRENT_FILED = 'CLEANUP_CURRENT_FILED'
export const SET_CURRENT_FIELD = 'SET_CURRENT_FIELD'
export const UPDATE_FIELD_NAME_IN_LIST = 'UPDATE_FIELD_NAME_IN_LIST'

export const SET_COUNT_TASKS_IN_CURRENT_FIELD = 'SET_COUNT_TASKS_IN_CURRENT_FIELD'

export const LIST_TASKS_SUCCESS = 'LIST_TASKS_SUCCESS'
export const SHOW_TASK_DETAIL = 'SHOW_TASK_DETAIL'
export const CLEANUP_CURRENT_TASK = 'CLEANUP_CURRENT_TASK'
export const SET_CURRENT_TASK = 'SET_CURRENT_TASK'

export const UPDATE_TASK_NAME_IN_LIST = 'UPDATE_TASK_NAME_IN_LIST'

export const UPDATE_PAGING_OPTIONS_OF_TASK_LIST = 'UPDATE_PAGING_OPTIONS_OF_TASK_LIST'
export const UPDATE_PAGING_OPTIONS_OF_FIELD_LIST = 'UPDATE_PAGING_OPTIONS_OF_FIELD_LIST'
export const UPDATE_LISTING_USER_OF_TASK_LIST = 'UPDATE_LISTING_USER_OF_TASK_LIST'

export const SET_PAGINATION_INFO = 'SET_PAGINATION_INFO'

export const CHANGE_MAP_STYLE = 'CHANGE_MAP_STYLE'
export const SET_MAP_CENTER = 'SET_MAP_CENTER'

export const CHANGE_MAP_TASK_COLORED_MODE = 'CHANGE_MAP_TASK_COLORED_MODE'
export const SET_GAUGE_VALUES = 'SET_GAUGE_VALUES'

export const SET_SYSTEM_OF_UNITS = 'SET_SYSTEM_OF_UNITS'

export const SET_SERACHED_USER_INFO = 'SET_SERACHED_USER_INFO'
export const CLEANUP_SERACHED_USER_INFO = 'CLEANUP_SERACHED_USER_INFO'

export const SET_SUBSCRIPTION_INFO = 'SET_SUBSCRIPTION_INFO'
export const SET_INCOMING_SUBSCRIPTION_REQUESTS = 'SET_INCOMING_SUBSCRIPTION_REQUESTS'
export const SET_OUTGOING_SUBSCRIPTION_REQUESTS = 'SET_OUTGOING_SUBSCRIPTION_REQUESTS'

// export const SET_PRODUCTS = 'SET_PRODUCTS'

export const SET_AVAILABLE_OPERATION_TYPES = 'SET_AVAILABLE_OPERATION_TYPES'

export const SET_LIST_VIEW_MODE = 'SET_LIST_VIEW_MODE'
export const SET_TASK_LIST_CURRENT_CALENDAR_MONTH = 'SET_TASK_LIST_CURRENT_CALENDAR_MONTH'

export const SET_PURCHASE_INFO = 'SET_PURCHASE_INFO'

export const SET_STRIPE_INFO = 'SET_STRIPE_INFO'

export const SET_BILLING_PLANS = 'SET_BILLING_PLANS'

export const ADD_SORACOM_SUBSCRIBER = 'ADD_SORACOM_SUBSCRIBER'

export const SET_AWS_SESSION_INFO = 'SET_AWS_SESSION_INFO'

export const SET_DEVICES_INFO = 'SET_DEVICES_INFO'
export const SET_WEB_MARKERS_INFO = 'SET_WEB_MARKERS_INFO'

export const INIT_REALTIME_INFOS = 'INIT_REALTIME_INFOS'
export const ADD_REALTIME_INFO = 'ADD_REALTIME_INFO'
export const REFRESH_REALTIME_INFO_ACTIVITIES = 'REFRESH_REALTIME_INFO_ACTIVITIES'
export const SET_NOW_SHOWING_REALTIME = 'SET_NOW_SHOWING_REALTIME'
export const SET_NOW_AUTO_TRACKING = 'SET_NOW_AUTO_TRACKING'

// @Deprecated
export const SHOW_TASKS_IN_FILED_WITH_MAP = 'SHOW_TASKS_IN_FILED_WITH_MAP'

export const FIELD_IMPORT_HIDE_MAP = 'FIELD_IMPORT_HIDE_MAP'

export const SET_DATE_FILTER_RANGE = 'SET_DATE_FILTER_RANGE'

export const PASSWORD_ENTERED = 'PASSWORD_ENTERED'

export const SET_INVIOCES = 'SET_INVIOCES'
export const SET_INVIOCE_UPCOMING = 'SET_INVIOCE_UPCOMING'

export const ADD_SUBSCRIBING_USER_INFO = 'ADD_SUBSCRIBING_USER_INFO'
export const CLEAR_SUBSCRIBING_USER_INFOS = 'CLEAR_SUBSCRIBING_USER_INFOS'

export const SET_REFLINES = 'SET_REFLINES'
export const UPDATE_PAGING_OPTIONS_OF_REFLINES_LIST = 'UPDATE_PAGING_OPTIONS_OF_REFLINES_LIST'
export const SET_CURRENT_REFLINE = 'SET_CURRENT_REFLINE'

export const SET_CURRENT_FILTER = 'SET_CURRENT_FILTER'

export const SET_CURRENT_TASK_WEATHER_INFO = 'SET_CURRENT_TASK_WEATHER_INFO'
export const SET_CURRENT_TASK_WEATHER_INFO_FROM_OPEN_METEO = 'SET_CURRENT_TASK_WEATHER_INFO_FROM_OPEN_METEO'

export const SET_USER_GROUPS_INFO = 'SET_USER_GROUPS_INFO'

export const SET_CENTROID_OF_USER_FIELDS = 'SET_CENTROID_OF_USER_FIELDS'

export const SET_PLANTINGS = 'SET_PLANTINGS'

export const SET_PF_OBSERVATIONS = 'SET_PF_OBSERVATIONS'
export const SET_AT_OBSERVATIONS = 'SET_AT_OBSERVATIONS'

export const SET_FIELD_GEO_JSONS = 'SET_FIELD_GEO_JSONS'

export const GROW_PUT_SOIL_MOISTURE = 'GROW_PUT_SOIL_MOISTURE'
export const GROW_PUT_SOIL_MOISTURE_FROM_OPEN_METEO = 'GROW_PUT_SOIL_MOISTURE_FROM_OPEN_METEO'
export const GROW_PUT_ACCUMULATED_TEMPERATURE = 'GROW_PUT_ACCUMULATED_TEMPERATURE'
export const GROW_PUT_ACCUMULATED_TEMPERATURE_FROM_OPEN_METEO = 'GROW_PUT_ACCUMULATED_TEMPERATURE_FROM_OPEN_METEO'

export const GROW_SET_GROW_PREDICTIONS = 'GROW_SET_GROW_PREDICTIONS'
export const GROW_SET_GROW_CROPS = 'GROW_SET_GROW_CROPS'

export const SET_RTK_BASES = 'SET_RTK_BASES'
export const SET_RTK_ROVERS = 'SET_RTK_ROVERS'
export const SET_RTK_SETTING_INFO = 'SET_RTK_SETTING_INFO'
export const SET_CASTER_STATS = 'SET_CASTER_STATS'
export const SET_CASTER_STATS_HISTORY = 'SET_CASTER_STATS_HISTORY'
export const SET_CASTER_TRACK = 'SET_CASTER_TRACK'

export const SET_SHOW_FIELD_PRINT = 'SET_SHOW_FIELD_PRINT'

export const SET_LIST_FIELD_SORT_OPTIONS = 'SET_LIST_FIELD_SORT_OPTIONS'

export const SET_CURRENT_FIELD_ELEVATION_MAP = 'SET_CURRENT_FIELD_ELEVATION_MAP'
export const CLEANUP_CURRENT_FILED_ELEVATION_MAP = 'CLEANUP_CURRENT_FILED_ELEVATION_MAP'

export const SET_LIST_COUPON = 'SET_LIST_COUPON'
